module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "href": "#/c006#TOC"
    }
  }, [_vm._v("Dedica")]), _c('a', {
    attrs: {
      "id": "Dedication"
    }
  })]), _c('a', {
    attrs: {
      "id": "Dedication"
    }
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])])]), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "id": "Dedication"
    }
  }, [_vm._v("A Valerie.")])]), _c('a', {
    attrs: {
      "id": "Dedication"
    }
  }, [_c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Sono piuttosto emozionato per i nostri secondi venticinque anni.")])]), _c('p', {
    staticStyle: {
      "font-size": "large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "id": "Dedication"
    }
  }), _c('a', {
    attrs: {
      "id": "TitlePage"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "768",
      "src": "d2d_images/image004.jpg",
      "width": "480"
    }
  })])]), _c('a', {
    attrs: {
      "id": "TitlePage"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26481a34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c007.vue
// module id = 78
// module chunks = 0